import type { BannerNotificationDto } from 'utils/api/dto';

const FOR_CLIENTS = 0;
const FOR_PLAYERS = 1;
const FOR_STAGING = 2;

const hasMaskBit = (mask: number | null | undefined, bit: number) =>
    typeof mask === 'number' && (mask & (1 << bit)) !== 0;

export const isAvailableForClients = (mask: number | null | undefined) => hasMaskBit(mask, FOR_CLIENTS);
export const isAvailableForPlayers = (mask: number | null | undefined) => hasMaskBit(mask, FOR_PLAYERS);
export const isOnlyStaging = (mask: number | null | undefined) => hasMaskBit(mask, FOR_STAGING);

/** A banner with the staging bit is shown on staging only, and staging shows only those (the product, TASK-318) */
export const isBannerForEnvironment = (mask: number | null | undefined, staging: boolean) =>
    isOnlyStaging(mask) === staging;

/**
 * The banner to show: the latest begun of the ones not ended yet, of this environment. The environment is checked
 * before choosing, so a newer staging banner does not hide the production one.
 */
export const selectLatestBanner = (banners: BannerNotificationDto[], now: Date, staging: boolean) =>
    banners
        .filter(
            ({ dateEnd, showMask }) => isBannerForEnvironment(showMask, staging) && !!dateEnd && new Date(dateEnd) > now
        )
        .sort((a, b) => new Date(b.dateBegin ?? 0).getTime() - new Date(a.dateBegin ?? 0).getTime())[0];
